import { ReactElement, useState } from 'react'
import { Flexbox } from '../../components/flexbox/flexbox'
import { ScreenTitle } from '../../components/screen-title/screen-title'
import { NumericFormat } from 'react-number-format'

const InvestingCycleScreen = (): ReactElement => {
  // Entire value
  const [capital, setCapital] = useState(10000000)

  const allocation = [
    {
      name: 'Trading Bot',
      percentage: 0.5,
      description: 'I do not know',
    },
    {
      name: 'DCA Bot',
      percentage: 0.4,
      description: 'I do not know',
      accounts: [
        { token: 'BTC', percentage: 0.625 },
        { token: 'ETH', percentage: 0.375 },
      ],
      profitThreshold: 0.1,
      profitAllocation: [
        {
          name: 'Self',
          percentage: 0.8,
        },
        {
          name: 'Bank',
          percentage: 0.2,
        },
      ],
    },
    {
      name: 'Experimental (Small caps)',
      percentage: 0.05,
      description: 'I do not know',
    },
    {
      name: 'Bank',
      percentage: 0.05,
      description: 'I do not know',
    },
  ]

  return (
    <Flexbox isCol flex={1}>
      <Flexbox flex={1} isCol>
        <ScreenTitle title={'Investing Cycle'} />
        <Flexbox>
          <div className="stats shadow">
            <div className="stat">
              <div className="stat-title">Capital Total</div>
              <div className="stat-value">
                <NumericFormat value={capital} thousandSeparator={','} prefix={'$'} />
              </div>
              <div className="stat-desc">0% more than last month</div>
            </div>
            <div className="stat">
              <div className="stat-title">Earnings Total</div>
              <div className="stat-value">
                <NumericFormat value={0} thousandSeparator={','} prefix={'$'} />
              </div>
              <div className="stat-desc">0 % more than last month</div>
            </div>
          </div>
        </Flexbox>
        <table className="table w-full">
          <thead>
            <tr>
              <th>Name</th>
              <th>Share / Percentage</th>
              <th>Funds Allocated</th>
              <th>Accounts</th>
              <th>Current Profit</th>
            </tr>
          </thead>
          <tbody>
            {allocation.map((item) => {
              return (
                <tr>
                  <td>
                    <div className="flex items-center space-x-3">
                      <div>
                        <div className="font-bold">{item.name}</div>
                        <div className="text-sm opacity-50">{item.description}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <NumericFormat
                      value={item.percentage * 100}
                      thousandSeparator={','}
                      suffix={'%'}
                    />
                  </td>
                  <td>
                    <NumericFormat
                      value={item.percentage * capital}
                      thousandSeparator={','}
                      prefix={'$'}
                    />
                  </td>
                  <td>
                    {item?.accounts?.map((account) => {
                      return (
                        <Flexbox isCol>
                          <Flexbox>Token: {account.token}</Flexbox>
                          <Flexbox>Allocation: {account.percentage}</Flexbox>
                          <Flexbox>
                            Amount: {}
                            <strong>
                              <NumericFormat
                                value={account.percentage * item.percentage * capital}
                                thousandSeparator={','}
                                prefix={'$'}
                                decimalScale={0}
                              />
                            </strong>
                          </Flexbox>
                        </Flexbox>
                      )
                    })}
                  </td>
                  <td>
                    <Flexbox isCol>
                      <Flexbox>
                        <strong>Threshold {(item.profitThreshold || 0) * 100} %</strong>
                      </Flexbox>
                      <Flexbox isCol>
                        {item.profitAllocation?.map((profit) => {
                          return (
                            <Flexbox>
                              {profit.name} = {profit.percentage * 100} %
                            </Flexbox>
                          )
                        })}
                      </Flexbox>
                    </Flexbox>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </Flexbox>
    </Flexbox>
  )
}

export default InvestingCycleScreen